const footerNav = [
  {
    title: "排查相关",
    links: [
      { href: "#symptoms", label: "常见现象" },
      { href: "#causes", label: "原因分析" },
      { href: "#steps", label: "8 步排查流程" },
      { href: "#quickcheck", label: "自检清单" },
    ],
  },
  {
    title: "专题内容",
    links: [
      { href: "#address", label: "地址失效" },
      { href: "#network", label: "网络屏蔽" },
      { href: "#safety", label: "安全提示" },
      { href: "#faq", label: "常见问答" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-50">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-play-circle-line"></i>
              </span>
              <span className="font-heading text-lg font-semibold">秋霞影院在线观看</span>
            </div>
            <p className="mt-4 text-sm text-background-200/85 leading-relaxed max-w-md">
              本站是一个访问异常排查的信息整理页面，围绕「打不开、无法访问、网页进不去、
              网站被屏蔽、看不了、地址失效」等常见问题，提供现象对照、原因分析与自查步骤。
            </p>
            <p className="mt-3 text-sm text-background-200/70 leading-relaxed max-w-md">
              本站不提供、不存储、不传播任何影视播放内容，也不涉及账号与支付。
            </p>
          </div>

          {footerNav.map((col) => (
            <div key={col.title} className="md:col-span-3">
              <p className="font-heading text-sm font-semibold text-background-50">{col.title}</p>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.href}>
                    <a
                      href={l.href}
                      className="text-sm text-background-200/85 hover:text-accent-400 transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1 flex md:justify-end">
            <a
              href="#top"
              aria-label="返回页面顶部"
              className="w-10 h-10 rounded-md bg-white/10 hover:bg-white/20 flex items-center justify-center text-lg transition-colors cursor-pointer"
            >
              <i className="ri-arrow-up-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-200/70">
            内容仅用于访问异常排查与信息参考，请通过正规渠道获取影视内容。
          </p>
          <p className="text-xs text-background-200/60">秋霞影院在线观看 · 访问异常排查信息页</p>
        </div>
      </div>
    </footer>
  );
}